import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * CommentsList Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Comments form section title
     */
    @Prop() title!: string;

    /**
     * Url_encode of post
     */
    @Prop() urlEncode!: string;

    /**
     * id of post
     */
    @Prop() postId!: string;

    /**
     * Type of post
     */
    @Prop() postType!: string;

    /**
     * Button text in header
     */
    @Prop() buttonText!: string;

    /**
     * Button link in header
     */
    @Prop() buttonLink!: string;

    /**
     * Button scroll effect
     * ScrollTo package
     */
    @Prop({ type: Boolean }) scrollButton!: boolean;

    /**
     * Enable pagination for the comments list
     */
    @Prop({ type: Boolean }) pagination!: boolean;

    /**
     * Length of comments in each page
     */
    @Prop() commentsPerPage!: string | number;

    /**
     * remove member avatar
     */
    @Prop({ type: Boolean }) removeAvatar!: boolean;

    /**
     * color
     */
    @Prop({ default: 'primary' }) color!: string;

    /**
     * Comments config
     */
    @Prop({ type: Object }) configs!: object;
}
